import React, { FC } from 'react';
import { StickyContainer, Sticky } from 'react-sticky';

import { ListingsContainer } from 'components/listings/Container';
import { ArtworksGridContainer } from 'components/artworksGrid/Container';
import { ArtworkPreviewModalContainer, ModalData } from 'components/artworkPreviewModal/Container';
import { GridTitle } from 'components/artworksGrid/GridTitle';
import { OPGridTitle } from 'components/artworksGrid/OPGridTitle';
import { PromoText } from 'apps/homepage/components/PromoText';
import { MODAL_ID } from 'apps/homepage/utils/modal';
import { HomePageHero } from 'apps/homepage/components/HomePageHero';

import { ChromecastProvider } from 'context/ChromecastContext';
import { LegacyArtwork } from 'types';

import { PdlCta, PdlLogoBlock } from 'pages/PublicDisplays/components';
import { CTA_CONTENT } from 'pages/PublicDisplays/pdlContent';

type StateProps = {
  loggedIn: boolean;
};
type DispatchProps = {
  afterOpenModal: (data: ModalData, artwork: LegacyArtwork) => void;
};

type Props = DispatchProps & StateProps;

export const App: FC<Props> = ({ afterOpenModal, loggedIn }) => (
  <>
    <HomePageHero />

    <section className="mt-4">

      <div className="video-section">
        <video autoPlay loop muted>
          <source src="https://sedition-website.s3.us-east-1.amazonaws.com/art-for-business/bring-art-to-business-bg.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        
        <div className="content-wrapper">
          <h1 className="headline">Bring Art To Your Business</h1>
          <p className="description">
            Tell us about your venue and your vision,
            <br />
            and our world-class curation team will curate a selection of artworks catered for your business.
          </p>
          <a className="btn btn--success" href="https://calendly.com/seditionart/30min" target="_blank" rel="noopener noreferrer">Book a call</a>
          <a className="btn btn--success" href="mailto:business@seditionart.com" target="_blank" rel="noopener noreferrer">Send us an email</a>
        </div>
      </div>

      <PdlLogoBlock />
    </section>

    <div className='container mt-3 mb-2'>
      {!loggedIn && <PromoText />}
      <div className='js-artwork-grid'>
        <GridTitle content='Artworks' url={Routes.artworks_path()} />
        <StickyContainer>
          <Sticky>
            {({ style, isSticky }) => (
              <div className='zi-2' style={{ ...style, backgroundColor: '#fff' }}>
                <ListingsContainer isSticky={isSticky} />
              </div>
            )}
          </Sticky>
          <div className='mt-2'>
            <ArtworksGridContainer type='curated' />
          </div>
          <ArtworksGridContainer {...{ type: 'op' }}>
            <OPGridTitle />
          </ArtworksGridContainer>
          <ChromecastProvider>
            <ArtworkPreviewModalContainer
              modalId={MODAL_ID}
              afterOpenModal={(modalData, artwork) => afterOpenModal(modalData, artwork)}
            />
          </ChromecastProvider>
        </StickyContainer>
      </div>
    </div>
  </>
);